import React from 'react';
import { Progress } from '@/components/ui/progress';

interface ProgressSectionProps {
  progressPercentage: number;
}

export const ProgressSection: React.FC<ProgressSectionProps> = ({
  progressPercentage
}) => {
  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-700">Progreso General</span>
        <span className="text-sm text-gray-600">{progressPercentage.toFixed(2)}%</span>
      </div>
      <Progress value={progressPercentage} className="h-2" />
    </div>
  );
};
